export default __webpack_public_path__ + "static/media/doctorAssLogo.830ab04d.png";